<template>
  <fieldset class="fieldset">
    <legend class="fieldset__label">
      {{ listLabel }}
    </legend>

    <button class="button _left-icon" @click="$emit('toggleSidebar')">
      <svg width="18" height="18">
        <use v-bind:xlink:href="`#${listType}`" />
      </svg>

      <span>Выбрать</span>
    </button>

    <div v-if="listData.length" class="search-filter__selected-items">
      {{ item.title | truncateText(100, 40) }}
      <span
        v-for="(item, index) in listData"
        :key="item.id"
        class="search-filter__selected-item"
      >
        {{ item.title | truncateText(100, 40) }}
        <span
          class="search-filter__selected-item-delete"
          @click="$emit('unselectItem', index)"
        >
          &times;
        </span>
      </span>
    </div>
  </fieldset>
</template>

<script>
export default {
  props: {
    listLabel: {
      type: String,
      required: true
    },
    listType: {
      type: String,
      required: true
    },
    listData: {
      type: Array,
      required: true,
      default: () => []
    }
  }
};
</script>
